import React from 'react';
import PropTypes from 'prop-types';
import useAuthentication from '../../../hooks/useAuthentication';
import { hasPrivilege } from '../../../hocs/withPrivileges';
import ReadonlyNumberField from '../../fields/ReadonlyNumberField';
import AuctionEnergyPerLot from './AuctionEnergyPerLot';

PrivilegedAuctionEnergyPerLot.propTypes = {
    sufficientPrivileges: PropTypes.arrayOf(PropTypes.string).isRequired,
    energyPerLot: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    quantityUnit: PropTypes.node.isRequired,
    className: PropTypes.string,
};

PrivilegedAuctionEnergyPerLot.defaultProps = {
    className: '',
};

function PrivilegedAuctionEnergyPerLot(props) {
    const {
        sufficientPrivileges,
        energyPerLot,
        label,
        quantityUnit,
        className,
        ...rest
    } = props;
    const { userPrivileges } = useAuthentication();
    return (
        hasPrivilege(userPrivileges, sufficientPrivileges)
            ? (
                <AuctionEnergyPerLot
                    label={label}
                    className={className}
                    quantityUnit={quantityUnit}
                    {...rest}
                />
            )
            : (
                <ReadonlyNumberField
                    label={label}
                    className={className}
                    value={energyPerLot}
                    postfix={quantityUnit}
                />
            )
    );
}

export default PrivilegedAuctionEnergyPerLot;
